export default (nums: number[]): boolean => new Set(nums).size !== nums.length;
